import React, { useState } from 'react';
import './CabDayPicker.css';
import './DayPickerCabReset.css';
import 'react-day-picker/lib/style.css';
import DayPicker, { DateUtils } from 'react-day-picker';

type MMTDatepickerProps = {
  updateFromDate: (from: Date, focusElem: string) => void;
  selectedFromDate: Date;
  selectedToDate: Date | undefined;
  updateToDate: (to: Date, focusElem: string, close: string) => void;
  inputName: string;
  fromMonth: Date | undefined;
};

const WEEKDAYS_SHORT = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

const MMTDatepicker = ({
  updateFromDate,
  selectedFromDate,
  selectedToDate,
  updateToDate,
  inputName,
  fromMonth
}: MMTDatepickerProps) => {
  const getNumberOfMonths = (isMobileDevice, numberOfMonths) => {
    if (numberOfMonths) return numberOfMonths;
    return 4;
  };
  const getInitialState = () => {
    return {
      from: selectedFromDate,
      to: selectedToDate,
      enteredTo: selectedToDate // Keep track of the last day for mouseEnter.
    };
  };

  const [state, setState] = useState(getInitialState());

  const customizingYear = () => {
    const elem = document.querySelectorAll('.DayPicker-Caption div');
    if (elem && elem.length > 0) {
      for (let i = 0; i < elem.length; i++) {
        const tempYr =
          parseInt(elem[i].innerHTML.split(' ')[1].replace(/\s/g, '')) % 2000;
        const correctedYr =
          elem[i].innerHTML.split(' ')[0] + '<span>' + tempYr + '</span>';

        elem[i].innerHTML = correctedYr;
      }
    }
  };

  const errorCase = (dayDiff: number, day: Date) => {
    const docRangeError = document.getElementById('range_error');
    const docDateError = document.getElementById('date_error');
    if (dayDiff === 1) {
      if (docRangeError) {
        docRangeError.style.display = 'none';
      }
      if (docDateError) {
        docDateError.style.display = 'block';
      }
      return;
    }

    if (dayDiff <= 0) {
      return;
    } else if (dayDiff > 30) {
      if (docDateError) {
        docDateError.style.display = 'none';
      }

      if (docRangeError) {
        docRangeError.style.display = 'block';
      }
      setTimeout(() => {
        if (docRangeError) {
          docRangeError.style.display = 'none';
        }
      }, 2000);
    } else {
      if (docRangeError) {
        docRangeError.style.display = 'none';
      }

      if (docDateError) {
        docDateError.style.display = 'none';
      }
    }
    setState({
      from: state.from,
      to: day,
      enteredTo: day
    });
    updateToDate(day, 'return', '');
  };

  const isSelectingFirstDay = (from, to, day) => {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  };

  const handleDayClick = (day: Date) => {
    const { from, to } = state;
    if (isSelectingFirstDay(from, to, day) && inputName !== 'return') {
      const docRangeError = document.getElementById('range_error');
      const docDateError = document.getElementById('date_error');

      if (docRangeError) docRangeError.style.display = 'none';

      if (docDateError) docDateError.style.display = 'none';

      if (from > day) {
        setState({
          from: day,
          to: undefined,
          enteredTo: undefined
        });
      } else {
        setState({
          from: day,
          to: undefined,
          enteredTo: undefined
        });
      }
      updateFromDate(day, 'return');
    } else {
      const dayDiff =
        Math.ceil((day.getTime() - from.getTime()) / (1000 * 60 * 60 * 24)) + 1;
      errorCase(dayDiff, day);
    }
  };

  const handleDayMouseEnter = day => {
    const { from, to } = state;
    if (!isSelectingFirstDay(from, to, day)) {
      setState({
        from: state.from,
        to: state.to,
        enteredTo: day
      });
    }
  };

  const today = new Date();
  const { from, to, enteredTo } = state;
  const modifiers = { start: from, end: to };
  let disabledDays = { before: today };
  if (inputName === 'return') {
    disabledDays = {
      before: new Date(state.from.getTime() + 1000 * 60 * 60 * 24)
    };
  }
  const selectedDays = [
    from,
    { from, to: enteredTo === undefined ? from : enteredTo }
  ]; //made changes
  const options = { year: '2-digit', month: 'short', day: 'numeric' };

  return (
    <div className="RangeExample noHeight">
      <div className="dayPickerHeader dayToFromCont blackText">
        <div className="calHeading makeFlex">
          <div
            className={`${
              from && to && inputName !== 'return'
                ? 'dateFiled active'
                : 'dateFiled'
            }`}
          >
            <p className="font16 blackText latoBold appendRight30">
              <span className="widgetSprite icCalendar appendRight10"></span>
              <span className="selectedDateField appendBottom8">
                {!from && 'Select CheckIn Date'}{' '}
                {from && `${from.toLocaleDateString('en-GB', options)}`}
              </span>
            </p>
          </div>
          <div className="font16 blackText latoBlack dashed appendRight30">
            {' '}
            -{' '}
          </div>
          <div
            className={`${
              (from && !to) || inputName === 'return'
                ? 'dateFiled active'
                : 'dateFiled'
            }`}
          >
            <p className="font16 blackText latoBold">
              <span className="widgetSprite icCalendar appendRight10"></span>
              <span className="selectedDateField appendBottom8">
                {!to && 'Select return Date'}{' '}
                {to && `${to.toLocaleDateString('en-GB', options)}`}
              </span>
            </p>
          </div>
        </div>
      </div>
      <p
        className="animated slideInUp errorBox font12 latoBold"
        id="date_error"
      >
        Select a valid date
      </p>

      <DayPicker
        className="Selectable Range"
        showOutsideDays
        month={new Date()}
        numberOfMonths={4}
        modifiers={modifiers}
        //years="2-digit"
        //value={selectedDays}
        selectedDays={selectedDays}
        onDayClick={handleDayClick}
        onMonthChange={customizingYear}
        disabledDays={disabledDays}
        weekdaysShort={WEEKDAYS_SHORT}
        onDayMouseEnter={handleDayMouseEnter}
        fromMonth={fromMonth}
      />
    </div>
  );
};
export default MMTDatepicker;
